<template>
  <footer class="main-footer">
    <strong>Copyright &copy; {{ year }}
    <a href="https://www.solidtectecnologia.com.br">Solidtec Tecnologia - (47) 3635-1755</a>.</strong> Todos os direitos reservados.
  </footer>
</template>

<script>
export default {
  name: 'DashFooter',
  data: function () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// DashFooter.vue?580dbab4